// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.practicepreferences.AdminSmartApplicationResponse */
/* istanbul ignore next */
@GandalfModel
export class AdminSmartApplicationResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	masterSmartApplicationId!: number | null;

	@GandalfProperty({ designType: String })
	masterSmartApplicationName!: string | null;

	@GandalfProperty({ designType: String })
	practiceComment!: string | null;

	@GandalfProperty({ designType: Boolean })
	practiceEnabled!: boolean | null;

}
